__turbopack_context__.v({
  "bot": "FooterBottom-module-scss-module__wIOTCG__bot",
  "mobileList": "FooterBottom-module-scss-module__wIOTCG__mobileList",
  "root": "FooterBottom-module-scss-module__wIOTCG__root",
  "top": "FooterBottom-module-scss-module__wIOTCG__top",
});
